import { Box } from 'ui';

export const TiltOverlay = ({ isCameraLevel }: { isCameraLevel: boolean }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        border: '4px solid',
        borderColor: isCameraLevel ? 'green' : 'red',
      }}
    />
  );
};
